import React from 'react';
import PropTypes from 'prop-types';
import { OpaqueWrapper } from '../../local/modals/styles/StyledComponents';
import { backArrow } from '../assets/backArrow';
import {
  SlideContainer,
  DialogContent,
  DialogHeader,
  BackButton,
  DialogBody
} from './styles/StyledComponents';

const SliderDialog = ({
  children,
  isOpen = false,
  onClose,
  slideDistance = '720px',
  shouldAnimate = true,
  slideFromLeft = false,
  zIndex = 1000,
  top = 0,
  right = 0,
  left,
  className,
  showBackButton = true
}) => {
  return (
    <>
      {isOpen && <OpaqueWrapper onClick={onClose} />}
      <SlideContainer
        top={top}
        right={right}
        left={left}
        $isOpen={isOpen}
        zIndex={zIndex}
        $slideDistance={slideDistance}
        $slideFromLeft={slideFromLeft}
        $shouldAnimateDesktop={shouldAnimate}
        className={className}
        role="dialog"
        aria-hidden={!isOpen}
        aria-modal={isOpen}
      >
        <DialogContent>
          <DialogHeader>
            {showBackButton && (
              <BackButton onClick={onClose} aria-label="Close dialog">
                {backArrow}
              </BackButton>
            )}
          </DialogHeader>

          <DialogBody>{children}</DialogBody>
        </DialogContent>
      </SlideContainer>
    </>
  );
};

SliderDialog.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  slideDistance: PropTypes.string,
  shouldAnimate: PropTypes.bool,
  slideFromLeft: PropTypes.bool,
  zIndex: PropTypes.number,
  top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  right: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  title: PropTypes.string,
  showBackButton: PropTypes.bool
};

export default SliderDialog;
